import type { Metadata } from "next";

/** Single global document title — no route-specific suffixes. */
export const SITE_TITLE = "Inora";

export const siteTitleMetadata: Pick<Metadata, "title"> = {
  title: {
    absolute: SITE_TITLE,
  },
};

/** Page-level metadata: always `Inora` for the tab; optional description only. */
export function createPageMetadata(description?: string): Metadata {
  return {
    ...siteTitleMetadata,
    ...(description ? { description } : {}),
  };
}
